(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      /* ========= 新增：监听菜单打开/关闭，控制 header--menu-open ========= */

      // 找到 header 里的所有一级菜单 <details>
      this.menuDetails = this.header.querySelectorAll('header-menu details');

      this.onMenuToggle = this.handleMenuToggle.bind(this);
      this.onDocumentClick = this.handleDocumentClick.bind(this);

      this.menuDetails.forEach((detailsEl) => {
        detailsEl.addEventListener('toggle', this.onMenuToggle);
      });

      // 点击 header 外部区域时，自动收起所有菜单
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      // 清理菜单事件监听
      if (this.menuDetails) {
        this.menuDetails.forEach((detailsEl) => {
          detailsEl.removeEventListener('toggle', this.onMenuToggle);
        });
      }
      document.removeEventListener('click', this.onDocumentClick);
    }

    /* 当任意一个 <details> 打开/关闭时触发 */
    handleMenuToggle() {
      if (!this.menuDetails) return;

      let anyOpen = false;
      this.menuDetails.forEach((d) => {
        if (d.open) anyOpen = true;
      });

      if (anyOpen) {
        // 只要有一个菜单打开：header 进入白底模式
        this.header.classList.add('header--menu-open', 'shopify-section-header-sticky');
      } else {
        // 所有菜单关闭：撤销白底标记，回到滚动/透明的正常逻辑
        this.header.classList.remove('header--menu-open');
      }
    }

    /* 点击 header 以外区域时，关闭所有菜单 */
    handleDocumentClick(event) {
      if (!this.header.contains(event.target)) {
        if (!this.menuDetails) return;

        let changed = false;
        this.menuDetails.forEach((d) => {
          if (d.open) {
            d.open = false;
            changed = true;
          }
        });

        if (changed) {
          this.handleMenuToggle();
        }
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`,
      );
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      // ═══ SELVANE: Malachite logo scroll is now handled by standalone <script> above ═══
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
      );
    }
  }

  customElements.define('sticky-header', StickyHeader);
    document.addEventListener('DOMContentLoaded', () => {
    const headerSection = document.querySelector('.section-header');
    if (!headerSection) return;

    /* ---------- 1. PC：hover header 时加 .header--hovered ---------- */
const headerBar = headerSection.querySelector('.bls_header');
if (headerBar) {
  const onEnter = () => headerSection.classList.add('header--hovered');
  const onLeave = () => headerSection.classList.remove('header--hovered');

  const hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  const desktopMQ = window.matchMedia('(min-width: 1025px)');

  const syncHoverBinding = () => {
    headerSection.classList.remove('header--hovered');

    headerBar.removeEventListener('mouseenter', onEnter);
    headerBar.removeEventListener('mouseleave', onLeave);

    if (hoverMQ.matches && desktopMQ.matches) {
      headerBar.addEventListener('mouseenter', onEnter);
      headerBar.addEventListener('mouseleave', onLeave);
    }
  };

  syncHoverBinding();
  hoverMQ.addEventListener('change', syncHoverBinding);
  desktopMQ.addEventListener('change', syncHoverBinding);
}

    document.addEventListener('DOMContentLoaded', () => {
  const localizationForms = document.querySelectorAll('localization-form');
  if (!localizationForms.length) return;

  localizationForms.forEach((form) => {
    const details = form.querySelector('details');
    if (!details) return; // 你的 snippet 如果不是 details，这段会自动跳过

    const close = () => {
      if (details.open) details.open = false;
    };

    // 1) 点击空白处收回
    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) close();
    });

    // 2) 用户点了某个币种（通常是 a / button），立刻收回
    form.addEventListener('click', (e) => {
      const t = e.target;
      if (!t) return;

      // 点到选项（a 或 button）就收起
      if (t.closest('a') || t.closest('button')) {
        // 给浏览器一拍时间让原本的 submit/跳转逻辑先触发
        setTimeout(close, 0);
      }
    }, true);

    // 3) 滚动时如果菜单开着，直接收回（避免你说的“滑动后状态乱跳/文字变白残留”）
    window.addEventListener('scroll', close, { passive: true });
  });
});


    /* ---------- 2. 所有菜单（PC 下拉 + mobile 侧边）统一控制 .header--menu-open ---------- */

    // PC 下拉菜单（header-menu 里的 <details>）
    const desktopDetails = headerSection.querySelectorAll('header-menu details');

    // mobile 侧边菜单的 checkbox
    const sideMenuCheckbox = document.getElementById('side-menu');

    const syncHeaderMenuOpen = () => {
      const anyDesktopOpen = Array.from(desktopDetails).some((d) => d.open);
      const mobileOpen = sideMenuCheckbox ? sideMenuCheckbox.checked : false;

      if (anyDesktopOpen || mobileOpen) {
        headerSection.classList.add('header--menu-open');
      } else {
        headerSection.classList.remove('header--menu-open');
      }
    };

    desktopDetails.forEach((detailsEl) => {
      detailsEl.addEventListener('toggle', syncHeaderMenuOpen);
    });

    if (sideMenuCheckbox) {
      sideMenuCheckbox.addEventListener('change', syncHeaderMenuOpen);
    }
  });
  document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('localization-form');

  const getCurrentCountryCode = (formEl) => {
    // 兼容常见写法：select 或 hidden input
    const select = formEl.querySelector('select[name="country_code"]');
    if (select && select.value) return select.value;

    const input = formEl.querySelector('input[name="country_code"]');
    if (input && input.value) return input.value;

    return null;
  };

  const markActive = (formEl) => {
    const current = getCurrentCountryCode(formEl);

    // 1) 找“触发器”：常见是 details > summary 或 button[aria-expanded]
    const trigger =
      formEl.querySelector('details > summary') ||
      formEl.querySelector('button[aria-expanded]') ||
      formEl.querySelector('summary');

    if (trigger) {
      trigger.classList.add('tl-localization-trigger', 'tl-is-active');
    }

    // 2) 尝试高亮下拉列表“当前选中项”
    // 不同主题的 country-localization 结构不同：这里用比较通用的 data-value 匹配
    const items = formEl.querySelectorAll('[data-value], [data-country-code]');
    items.forEach((el) => {
      const val = el.getAttribute('data-country-code') || el.getAttribute('data-value');
      el.classList.add('tl-localization-item');
      el.classList.toggle('tl-is-selected', !!current && val === current);
    });
  };

  const syncScrollLock = () => {
    // 大多数主题用 <details> 控制下拉
    const anyOpen = Array.from(document.querySelectorAll('localization-form details'))
      .some((d) => d.open);
    document.documentElement.classList.toggle('tl-localization-open', anyOpen);
  };

  forms.forEach((f) => {
    markActive(f);

    // 打开/关闭下拉时：锁滚动，避免滚动导致 header 状态/背景乱跳
    const details = f.querySelector('details');
    if (details) details.addEventListener('toggle', syncScrollLock);

    // 切换后页面会刷新：刷新前先把选中项写入（让刷新后仍能高亮列表项）
    const form = f.querySelector('form');
    if (form) {
      form.addEventListener(
        'submit',
        () => {
          const select = form.querySelector('select[name="country_code"]');
          const code = select?.value || form.querySelector('input[name="country_code"]')?.value;
          if (code) sessionStorage.setItem('tl_country_code', code);
        },
        true
      );
    }
  });

  // 刷新后再次兜底：如果有 sessionStorage，就用它再标一遍（避免用户觉得“没变”）
  const stored = sessionStorage.getItem('tl_country_code');
  if (stored) {
    sessionStorage.removeItem('tl_country_code');
    forms.forEach((f) => markActive(f));
  }

  syncScrollLock();
});



  } catch(e) { console.error(e); }
})();
})();
